import React from 'react';
import Icon from '../../../components/AppIcon';

const TimesheetSummary = ({ summary, hourlyRate, selectedDate }) => {
  const getPeriodLabel = (selectedDate) => {
    if (!selectedDate) {
      return 'All Entries';
    }
    const date = new Date(selectedDate + 'T00:00:00');
    return date.toLocaleDateString('en-US', {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  // Format numbers to 2 decimal places
  const formatHours = (hours) => {
    const num = typeof hours === 'string' ? parseFloat(hours) : hours;
    return isNaN(num) ? 0 : num.toFixed(2);
  };

  const formatAmount = (amount) => {
    const num = typeof amount === 'string' ? parseFloat(amount) : amount;
    return isNaN(num) ? '0.00' : num.toFixed(2);
  };

  const summaryCards = [
    {
      title: 'Total Hours',
      value: `${formatHours(summary.totalHours)}h`,
      icon: 'Clock',
      color: 'bg-blue-50',
      iconColor: 'text-blue-500'
    },
    {
      title: 'Approved Hours',
      value: `${formatHours(summary.approvedHours)}h`,
      icon: 'CheckCircle',
      color: 'bg-success-50',
      iconColor: 'text-success-500'
    },
    {
      title: 'Pending Hours',
      value: `${formatHours(summary.pendingHours)}h`,
      icon: 'Clock',
      color: 'bg-warning-50',
      iconColor: 'text-warning-500'
    },
    {
      title: 'Total Earnings',
      value: `$${formatAmount(summary.totalAmount)}`,
      icon: 'DollarSign',
      color: 'bg-accent-50',
      iconColor: 'text-accent-500'
    }
  ];

  return (
    <div className="bg-white rounded-lg border border-border p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-text-primary">Summary</h2>
        <span className="text-sm text-text-secondary">{getPeriodLabel(selectedDate)}</span>
      </div>
      
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {summaryCards.map((card, index) => (
          <div key={index} className="text-center">
            <div className={`w-12 h-12 rounded-full ${card.color} flex items-center justify-center mx-auto mb-2`}>
              <Icon name={card.icon} size={20} className={card.iconColor} />
            </div>
            <div className="text-2xl font-bold text-text-primary mb-1">
              {card.value}
            </div>
            <div className="text-xs text-text-secondary">
              {card.title}
            </div>
          </div>
        ))}
      </div>

      {hourlyRate > 0 && (
        <div className="mt-4 pt-4 border-t border-border">
          <div className="flex items-center justify-between text-sm">
            <span className="text-text-secondary">Hourly Rate:</span>
            <span className="font-medium text-text-primary">
              ${typeof hourlyRate === 'string' ? parseFloat(hourlyRate).toFixed(2) : hourlyRate.toFixed(2)}/hr
            </span>
          </div>
          <div className="flex items-center justify-between text-sm mt-2">
            <span className="text-text-secondary">Approved Earnings:</span>
            <span className="font-medium text-success">
              ${formatAmount((parseFloat(summary.approvedHours || 0) * parseFloat(hourlyRate || 0)))}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default TimesheetSummary;
